module.exports = __webpack_public_path__ + "static/img/2019.2bc72a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2019.png
// module id = KPeQ
// module chunks = 1